<form [formGroup]="formName">
  <label *ngFor="let option of field.options">
    <input
      [formControlName]="field.filterKey"
      [name]="field.label"
      [type]="field.type"
      [value]="field.value"
    >
    {{option.label}}
  </label>
</form>
